import { useEffect, useState } from "react";
import { tg } from "../telegram";
import { useT } from "../i18n";
import { nf, useNorms } from "../hooks/useNorms";
import IncidentsPanel from "./IncidentsPanel";
import EventsFeed from "./EventsFeed";
import { AlarmsSub, DrillModal, DrillTableSub, OverviewSub, VBandSub } from "./CombinedPanel";

type Sub = "feed" | "incidents" | "alarms" | "spikes" | "vband" | "drill";

// «События»: the four hand-made разборы (ex «Аварии») and the station-wide
// views that used to live under «Общая» — alarms journal, voltage spikes,
// the voltage corridor (norm, 19–21 kV by default) and the per-source drill table.
// Step 4 adds the automatic event feed on top of these.
export default function EventsPanel({ hasUnits, hasIncidents, hasCombined }: { hasUnits: boolean; hasIncidents: boolean; hasCombined: boolean }) {
  const { t, lang } = useT();
  const norms = useNorms();
  const [caseKey, setCaseKey] = useState<string | null>(null);
  const subs: { k: Sub; label: string }[] = [
    { k: "feed", label: t("events.sub_feed") },
    ...(hasIncidents ? [{ k: "incidents" as Sub, label: t("events.sub_incidents") }] : []),
    ...(hasCombined ? [
      { k: "alarms" as Sub, label: t("combined.sub_alarms") },
      { k: "spikes" as Sub, label: t("events.sub_spikes") },
      { k: "vband" as Sub, label: t("combined.sub_vband", { lo: nf(norms.v_lo, lang), hi: nf(norms.v_hi, lang) }) },
      { k: "drill" as Sub, label: t("combined.sub_drill") },
    ] : []),
  ];
  const [sub, setSub] = useState<Sub>("feed");
  const [error, setError] = useState<string | null>(null);
  // The alarms list opens the same telemetry drill as the spike lists (custom event, see CombinedPanel).
  const [detail, setDetail] = useState<{ src: string; win?: string; at?: string } | null>(null);
  useEffect(() => {
    const h = (e: Event) => {
      const d = (e as CustomEvent).detail as { src: string; win?: string; at?: string };
      if (d && d.src && (d.win || d.at)) setDetail(d);
    };
    window.addEventListener("combined:show-detail", h);
    return () => window.removeEventListener("combined:show-detail", h);
  }, []);

  return (
    <div>
      <h1>{t("tabs.events")}</h1>
      <div className="period-tabs" style={{ marginBottom: 12 }}>
        {subs.map(s => (
          <button key={s.k} className={"period-tab" + (sub === s.k ? " active" : "")}
            onClick={() => { tg()?.HapticFeedback?.selectionChanged?.(); setError(null); setSub(s.k); }}>
            {s.label}
          </button>
        ))}
      </div>
      {error && <div className="alert error">{error}</div>}
      {sub === "feed" && <EventsFeed hasUnits={hasUnits} hasAlarms={hasCombined} hasCases={hasIncidents} onOpenCase={(k) => { setCaseKey(k); setSub("incidents"); }} />}
      {sub === "incidents" && <IncidentsPanel embedded initialKey={caseKey} />}
      {sub === "alarms" && <AlarmsSub onErr={setError} />}
      {sub === "spikes" && <OverviewSub onErr={setError} openDetail={setDetail} showKpi={false} />}
      {sub === "vband" && <VBandSub onErr={setError} openDetail={setDetail} />}
      {sub === "drill" && <DrillTableSub onErr={setError} />}
      {detail && <DrillModal src={detail.src} win={detail.win} at={detail.at} onClose={() => setDetail(null)} />}
    </div>
  );
}
